export enum UserType {
  'RESIDENT' = 'resident',
  'SUPPORTER' = 'supporter',
  'STAFF' = 'staff',
  'CUSTOMER_ADMIN' = 'customeradmin',
}
